import PropTypes from 'prop-types';
import { PAConstants, WMICVehicleUtil } from 'wmic-pe-portals-utils-js';
import styles from './WMICDriverEndorsementsDetailsComponent.module.scss';
import { Icon } from '@jutro/legacy/components';

function WMICDriverEndorsementsDetailsComponent(props) {
    const { checked, driverEndorsementPublicID, existingEndorsements, readOnly, vehicles } = props;

    const checkBoxIconStyle = readOnly ? styles.checkIconReadOnly : styles.checkIconEdit;

    const isCheckBoxDetailsVisible = () =>
        checked &&
        [PAConstants.reducAmtForNamedCov_28A_PublicId, PAConstants.reducAmtForNamedCov_28_PublicId].includes(
            driverEndorsementPublicID
        ) &&
        existingEndorsements?.length > 0;

    const renderVehicleItem = vehicle => (
        <li key={vehicle.publicID} className={styles.vehicleItem}>
            <Icon tag="span" icon="mi-check" className={checkBoxIconStyle} />
            <span className={styles.vehicleName}>{WMICVehicleUtil.formatVehicleDisplayLabel(vehicle)}</span>
        </li>
    );

    const renderEndorsementVehicleItem = endorsement =>
        endorsement.vehiclePublicID?.value && (
            <li key={`${endorsement?.publicID}-${endorsement?.vehiclePublicID?.value}`} className={styles.vehicleItem}>
                <Icon tag="span" icon="mi-check" className={checkBoxIconStyle} />
                <span className={styles.vehicleName}>
                    {WMICVehicleUtil.formatVehicleDisplayLabelFromVehiclePublicID(
                        endorsement.vehiclePublicID.value,
                        vehicles
                    )}
                </span>
            </li>
        );

    const renderEndorsementVehiclesList = existingEndorsements => (
        <div>
            <ul className={styles.vehicleList}>
                {existingEndorsements?.map(endorsement => renderEndorsementVehicleItem(endorsement))}
            </ul>
        </div>
    );

    const renderAllVehiclesList = vehicles => (
        <div>
            <ul className={styles.vehicleList}>{vehicles?.map(vehicle => renderVehicleItem(vehicle))}</ul>
        </div>
    );

    return (
        isCheckBoxDetailsVisible() && (
            <div className={styles.endorsementDetailsContainer}>
                {existingEndorsements.some(endorsement => endorsement.allVehicles?.value === true)
                    ? renderAllVehiclesList(vehicles)
                    : renderEndorsementVehiclesList(existingEndorsements)}
            </div>
        )
    );
}

WMICDriverEndorsementsDetailsComponent.propTypes = {
    checked: PropTypes.bool.isRequired,
    driverEndorsementPublicID: PropTypes.string.isRequired,
    existingEndorsements: PropTypes.shape([]).isRequired,
    readOnly: PropTypes.bool.isRequired,
    vehicles: PropTypes.shape([]).isRequired,
};

export default WMICDriverEndorsementsDetailsComponent;
